import { Lead } from 'features/PropertyDetails/infra/remote/getProperty/Lead.type'
import { parseLeadResponse } from 'features/PropertyDetails/infra/remote/getProperty/parseLeadResponse'
import { restClient } from 'presentation/libs/client'

export const getLead = async (id: string): Promise<Lead> =>
  await restClient.get(`legacy/leads/${id}`)
    .json()
    .then(parseLeadResponse)
